module.exports = __webpack_public_path__ + "static/media/personal.31f497f1.png";